var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { useTranslation } from 'react-i18next';
export var AcceptVtoSuccessButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (React.createElement(StyledButton, { onClick: onClick, "aria-label": t('shift_management_common_ok'), "alt-text": t('shift_management_common_button', {
            label: t('shift_management_common_ok')
        }), dataTestId: "AcceptVtoSuccessButton", variant: ButtonVariant.Primary }, t('shift_management_common_ok')));
};
var StyledButton = styledWithTheme(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
